import React from 'react';
import { Box, Typography } from '@compass/core';
import {
    Chart,
    Series,
    ArgumentAxis,
    ValueAxis,
    Legend,
    Tooltip,
    Label,
    Title,
    Export,
} from 'devextreme-react/chart';
import { SchoolEnrollmentSummaryDto } from 'generated/openApi';

interface SchoolEnrollmentChartProps {
    data: SchoolEnrollmentSummaryDto[];
}

export const SchoolEnrollmentChart = ({ data }: SchoolEnrollmentChartProps) => {
    if (data.length === 0) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: 300,
                    color: 'text.secondary',
                }}
            >
                <Typography variant="body1">No enrollment data available</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ width: '100%', height: '100%', minHeight: 400, display: 'flex', flexDirection: 'column' }}>
            <Chart dataSource={data} rotated={true}>
                <Series
                    valueField="enrollmentCount"
                    argumentField="schoolName"
                    type="bar"
                    color="#3182bd"
                />

                <ArgumentAxis>
                    <Label wordWrap="none" overlappingBehavior="rotate" />
                </ArgumentAxis>

                <ValueAxis>
                    <Title text="Enrollment Count" />
                </ValueAxis>

                <Legend visible={false} />

                <Tooltip
                    enabled={true}
                    customizeTooltip={(pointInfo: any) => ({
                        text: `${pointInfo.argumentText}: ${pointInfo.valueText} students`,
                    })}
                />
                
                <Export enabled={true} />
            </Chart>
        </Box>
    );
};